// React
import React from 'react';
// Material-UI
import { IconButton } from '@material-ui/core';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ClearIcon from "@material-ui/icons/Clear";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
// Otras libs

// Componentes

// Funciones

// Hooks


/**
 * Especifica la función a ser ejecutada al cambiar de fecha
 * @callback OnChange
 * @param {Date} fecha - Nueva fecha
 * @returns {void}
 */

/**
 *
 * @typedef {Object} Props
 * @property {string} name Nombre de elemento
 * @property {string} label Etiqueta
 * @property {Date | null} value Fecha
 * @property {boolean} clearable Si componente permite eliminar fecha
 * @property {Date | undefined} [minDate] Fecha mínima
 * @property {Date | undefined} [maxDate] Fecha maxima
 * @property {string} [format] Formato de fecha
 * @property {number} [minutesStep] Pasos por minutos
 * @property {boolean} [ampm] 12h/24h
 * @property {OnChange} onChange Evento al cambiar de fecha
 */

/**
 * Lista
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const SelectorFechaHora = ({ 
    name = '',
    label = '',
    value = null, 
    clearable = false,
    minDate = undefined,
    maxDate = undefined,
    format = 'dd/MM/yyyy',
    minutesStep = 1,
    ampm = true,
    onChange = (fecha) => {},
 }) => {
    // Idioma

    // Estados

    // Vista
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
            <KeyboardDateTimePicker
                name={name}
                label={label}
                inputVariant="outlined"
                format={format}
                minutesStep={minutesStep}
                ampm={ampm}
                fullWidth
                size="small"
                value={value}
                onChange={(d, v) => onChange(d)}
                clearable={clearable}
                minDate={minDate}
                maxDate={maxDate}
                InputProps={clearable 
                    ? {
                        endAdornment: (
                            <IconButton size="small" onClick={() => onChange(null)}>
                                <ClearIcon />
                            </IconButton>
                        )
                    } : undefined
                }
                InputAdornmentProps={clearable
                    ? { position: "start"}
                    : undefined
                }
            />
        </MuiPickersUtilsProvider>
    );
};
